<template>
  <form-layout title="Edit Batch" @on-dismiss="dismiss">
    <batch-edit-form-fields
      :id="props.id"
      @batch-updated="dismiss"
      @show-snackbar="(message) => (snackbarMessage = message)"
      @show-snackbar-error="
        (message) => {
          errorMessage = message
          showSnackbarError = true
        }
      "
    />
    <template #snack-bar-wrapper>
      <vs-snackbar :value="!!snackbarMessage" sticky type="info" @input="clearSnackbarMessage"
        >{{ snackbarMessage }}
      </vs-snackbar>
      <vs-snackbar :value="showSnackbarError" sticky type="error" @input="clearSnackbarError">
        {{ errorMessage }}
      </vs-snackbar>
    </template>
  </form-layout>
</template>

<script setup lang="ts">
import FormLayout from '@/components/common/FormLayout.vue'
import { AxiosError } from 'axios'
import { ref } from 'vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'
import BatchEditFormFields from '@/components/batches/BatchEditFormFields.vue'

const props = defineProps<{
  id: string
}>()

const snackbarMessage = ref<string | null>(null)
const showSnackbarError = ref<boolean>(false)
const errorMessage = ref<string | AxiosError<unknown, any> | null>(null)

const emit = defineEmits<{
  (e: 'dismiss')
}>()

function clearSnackbarMessage() {
  snackbarMessage.value = null
}

function clearSnackbarError() {
  showSnackbarError.value = false
}

function dismiss() {
  emit('dismiss')
}
</script>
<style scoped>
.sync-target-form {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
</style>
